import Vue from "vue";
import Vuex from "vuex";
import createLogger from "vuex/dist/logger";
import { getAuth, onAuthStateChanged } from "firebase/auth";

import router from "../router";

import auth from "./modules/auth";
import leads from "./modules/leads";
import community from "./modules/community";
import trainings from "./modules/trainings";
import files from "./modules/files";
import common from "./modules/common";
import chat from "./modules/chat";
import aiChat from "./modules/aiChat";
import jlai from "./modules/jlai";
import numerology from "./modules/numerology";
import checkout from "./modules/checkout";
import mailing from "./modules/mailing";

import { clearRefreshTokenTimeout, putTokenToStorage } from "@/helpers/auth";

import { INIT, GET_AUTH, UPDATE_AUTH_STATE } from "./actions";
import { SET_INITIALIZED, SET_AUTH, PURGE_AUTH } from "./mutations";

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		initialized: false,
	},
	modules: {
		auth,
		leads,
		community,
		trainings,
		files,
		common,
		chat,
		aiChat,
		jlai,
		numerology,
		checkout,
		mailing,
	},
	plugins: [
		...(process.env.NODE_ENV === "development" ? [createLogger()] : []),
		auth.plugin,
	],
	mutations: {
		[SET_INITIALIZED](state, value) {
			state.initialized = value;
		},
	},
	actions: {
		async [INIT]({ state, commit }) {
			await new Promise((resolve) => {
				const auth = getAuth();

				onAuthStateChanged(auth, async (user) => {
					const initialized = state["auth/initialized"];

					if (!user) {
						clearRefreshTokenTimeout();
						localStorage.removeItem("token");

						if (initialized) {
							store.commit(`auth/${PURGE_AUTH}`); // clear store if user was logged out
							router.push({ name: "login" }); // force redirect from private route
						}
					} else {
						const { token } = await user.getIdTokenResult(true);
						putTokenToStorage(token);

						store.commit(`auth/${SET_AUTH}`, user);
						await store.dispatch(`auth/${GET_AUTH}`);
						await store.dispatch(`auth/${UPDATE_AUTH_STATE}`);
						if (initialized) router.push({ name: "dashboard" });
					}
					if (!initialized) resolve();
				});
			});

			commit(SET_INITIALIZED, true);
		},
	},
});

export default store;
